// Ostatnie wyszukiwanie w samochodach osobowych: zapis na listingu, odczyt na stronie głównej.
// Tylko localStorage, bez danych na serwerze.
export const LAST_SEARCH_KEY = 'spl:ostatnie-wyszukiwanie'

const MAX_LABEL = 120
const MAX_URL = 1000

const fmt = (n) => String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
const num = (v) => /^\d+$/.test(String(v ?? '')) ? Number(v) : null
const str = (v) => {
    if (Array.isArray(v)) v = v.join(', ')
    return (typeof v === 'string' || typeof v === 'number') ? String(v).trim() : ''
}

const hasControlChars = (s) => {
    for (let i = 0; i < s.length; i++) {
        const c = s.charCodeAt(i)
        if (c < 32 || c === 127) return true
    }
    return false
}

// Ścieżka w obrębie serwisu: zaczyna się od „/”, bez „//” i „/\”. Znaki sterujące
// odrzucone, bo przeglądarka usuwa tabulatory i nowe linie z adresu („/\t/x” → „//x”).
export function isSafePath (url) {
    return typeof url === 'string'
        && url.length <= MAX_URL
        && !hasControlChars(url)
        && /^\/(?![/\\])/.test(url)
}

// Etykieta wyszukiwania albo null, gdy w zapytaniu nie ma marki, modelu, typu nadwozia ani ceny.
export function lastSearchLabel (query) {
    const q = query || {}
    const make = str(q.marka)
    const model = str(q.model)
    const type = str(q['typ-nadwozia'])
    const priceFrom = num(q['cena-od'])
    const priceTo = num(q['cena-do'])
    if (!make && !model && !type && priceFrom === null && priceTo === null) return null

    const parts = []
    const name = [make, model].filter(Boolean).join(' ')
    if (name) parts.push(name)
    if (type) parts.push(type)
    if (!parts.length) parts.push('Osobowe')

    if (priceFrom !== null && priceTo !== null) parts.push(`${fmt(priceFrom)}–${fmt(priceTo)} zł`)
    else if (priceTo !== null) parts.push(`do ${fmt(priceTo)} zł`)
    else if (priceFrom !== null) parts.push(`od ${fmt(priceFrom)} zł`)

    const yearFrom = num(q['rocznik-od'])
    if (yearFrom !== null) parts.push(`od ${yearFrom}`)

    return parts.join(', ').slice(0, MAX_LABEL)
}

// Adres listingu do zapisu: bez numeru strony wyników.
export function lastSearchUrl (pathname, search) {
    const params = new URLSearchParams(search || '')
    params.delete('strona')
    const qs = params.toString()
    return `${pathname}${qs ? `?${qs}` : ''}`
}

export function readLastSearch () {
    try {
        const d = JSON.parse(localStorage.getItem(LAST_SEARCH_KEY))
        if (d && typeof d.label === 'string' && d.label && d.label.length <= MAX_LABEL && isSafePath(d.url)
            && new URL(d.url, location.origin).origin === location.origin) {
            return { label: d.label, url: d.url }
        }
    } catch (err) { /* brak dostępu do localStorage albo uszkodzony wpis */ }
    return null
}

export function writeLastSearch (label, url) {
    if (!label || !isSafePath(url)) return
    try { localStorage.setItem(LAST_SEARCH_KEY, JSON.stringify({ label, url })) } catch (err) { /* tryb prywatny: pomiń */ }
}

export function clearLastSearch () {
    try { localStorage.removeItem(LAST_SEARCH_KEY) } catch (err) { /* tryb prywatny: pomiń */ }
}
